import { Fragment } from 'react';
import { Zap } from 'lucide-react';
import { AvatarStack, Eyebrow } from './bits';

const IMPACT = [{ v: 3, label: 'High impact' }, { v: 2, label: 'Medium' }, { v: 1, label: 'Low' }];
const EFFORT = [{ v: 1, label: 'Low effort' }, { v: 2, label: 'Medium' }, { v: 3, label: 'High' }];
const CELL_LABEL = { '3-1': 'Do these first', '3-2': 'Plan them in', '3-3': 'Big bets', '2-1': 'Fill-in jobs', '1-3': 'Probably not' };

export function BizQuickWins({ items, onOpen }) {
  const open = items.filter((i) => i.status !== 'done');
  return (
    <div data-testid="biz-quickwins">
      <div className="flex items-end justify-between mb-5 flex-wrap gap-3">
        <div>
          <Eyebrow>Impact × Effort</Eyebrow>
          <p className="text-sm mt-1 max-w-3xl" style={{ color: 'var(--ink-2)' }}>Everything that isn’t done, placed by how much it moves the business against how hard it is. Top-left is where mornings should start.</p>
        </div>
        <span className="biz-chip" style={{ background: open.some((i) => i.impact === 3 && i.effort === 1) ? 'var(--sage-soft)' : 'var(--paper-3)', color: open.some((i) => i.impact === 3 && i.effort === 1) ? 'var(--sage-deep)' : 'var(--ink-2)' }} data-testid="biz-quickwins-count"><Zap className="w-3 h-3" /> {open.filter((i) => i.impact === 3 && i.effort === 1).length} quick wins ready</span>
      </div>
      <div className="grid gap-3" style={{ gridTemplateColumns: '120px repeat(3, minmax(0, 1fr))' }}>
        <div />
        {EFFORT.map((e) => <div key={e.v} className="text-center text-[13px] font-semibold py-1.5" style={{ color: 'var(--ink-2)' }}>{e.label}</div>)}
        {IMPACT.map((im) => (
          <Fragment key={im.v}>
            <div className="text-[13px] font-semibold flex items-center justify-end pr-4 text-right" style={{ color: 'var(--ink-2)' }}>{im.label}</div>
            {EFFORT.map((e) => {
              const cell = open.filter((i) => i.impact === im.v && i.effort === e.v);
              const hot = im.v === 3 && e.v === 1;
              const label = CELL_LABEL[`${im.v}-${e.v}`];
              return (
                <div key={`${im.v}-${e.v}`} data-testid={`biz-cell-${im.v}-${e.v}`} className="rounded-2xl p-4 min-h-[132px] transition-colors"
                  style={{ background: hot ? 'var(--apricot-soft)' : 'var(--paper-2)', border: `1px solid ${hot ? 'var(--apricot)' : 'var(--line)'}` }}>
                  {label && <p className="text-xs uppercase tracking-[0.14em] font-semibold mb-2.5" style={{ color: hot ? 'var(--apricot-deep)' : 'var(--ink-3)' }}>{label}</p>}
                  <div className="flex flex-wrap gap-2">
                    {cell.map((i) => (
                      <button key={i.id} type="button" onClick={() => onOpen(i.id)} data-testid={`biz-qw-${i.id}`}
                        className="inline-flex items-center gap-2 text-[13px] font-medium pl-1 pr-3 py-1 rounded-full transition-transform hover:-translate-y-0.5 text-left"
                        style={{ background: hot ? '#fff' : 'var(--paper-3)', color: 'var(--ink)', border: '1px solid var(--line)' }}>
                        <AvatarStack entity={i} size={22} /> {i.title}
                      </button>
                    ))}
                  </div>
                </div>
              );
            })}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
